<template>
    <form style="position: relative">
      <div style="position:absolute; top: 10px; right: 10px;">
      <CopyBlock :sharedData="sharedData" />
      </div>
      <h2>Heading Block</h2>
      <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.Text.Editor') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
        <div class="divider">
          <label class="contentLabel" for="textContent">{{ $t('Add.Text.Content') }}</label>
          <div class="editor">
            <!-- Toolbar -->
            <div class="toolbar">
              <button type="button" @click="emitUndo">
                <span class="material-symbols-outlined">undo</span>
              </button>
              <button type="button" @click="emitRedo">
                <span class="material-symbols-outlined">redo</span>
              </button>
              <button type="button" @click="emitToggleItalic"><i>I</i></button>
              <button type="button" @click="emitToggleUnderline"><u>U</u></button>
              <button type="button" @click="emitToggleStrike"><s>S</s></button>
              <button type="button" @click="emitMarkPlaceholder">
                <span class="material-symbols-outlined toolbarIcon">bolt</span>
              </button>
              <button type="button" @click="emitEnterRule">
                <span class="material-symbols-outlined toolbarIcon">rule</span>
              </button>
              <button type="button" @click="emitAddLink">
                <span class="material-symbols-outlined toolbarIcon">link</span>
              </button>
              <button type="button" @click="emitSubscript">
                <span class="material-symbols-outlined toolbarIcon">subscript</span>
              </button>
              <button type="button" @click="emitSuperscript">
                <span class="material-symbols-outlined toolbarIcon">superscript</span>
              </button>
            </div>
          <!-- Weitere Komponenten wie Modals etc. können hier folgen -->
          <div class="divider">
        <p>{{ $t('Add.Heading.Level') }}</p>
        <div class="input-container">
          <label>
            <input
              type="radio"
              class="radios"
              name="level"
              value="h1"
              v-model="level"
            />
            <span class="radioSelect firstSelect"
              ><span class="material-symbols-outlined">format_h1</span></span
            >
          </label>
          <label>
            <input
              type="radio"
              class="radios"
              name="level"
              value="h2"
              v-model="level"
            />
            <span class="radioSelect"
              ><span class="material-symbols-outlined">format_h2</span></span
            >
          </label>
          <label class="last">
            <input
              type="radio"
              class="radios"
              name="level"
              value="h3"
              v-model="level"
            />
            <span class="radioSelect lastSelect"
              ><span class="material-symbols-outlined">format_h3</span></span
            >
          </label> 
        </div>
      </div>
          <FontFamilyProp :sharedData="sharedData"/>
          <div class="divider">
            <label class="contentLabel" for="textColor">Text Color</label>
            <div class="color-container">
              <input 
                type="color" id="textColor" name="textC"
                :value="color"  
                @input="emitColor($event.target.value)"
               />
              <span v-if="color" class="material-symbols-outlined reset-color" @click="emitResetColor">refresh</span>
              <div v-else class="add-color-overlay">+</div>
            </div>
          </div>
          <!-- <TextColorProp :sharedData="sharedData"/> -->
          <BackgroundColorProp :sharedData="sharedData"/>
        </div>
      </div>
      </div>
    </div>
     <!-- Reiter: Style -->
     <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('style')" class="accordion-content">
      <NameProp :sharedData="sharedData" />
      <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
      <!-- Reiter: Positioning -->
      <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('positioning')" class="accordion-content">
      <AlignmentProp :sharedData="sharedData" />
      <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
    </form>
  </template>
  
  <script>
import TextEditorModal from '../Reusables/TextEditorModal.vue'
import TextColorProp from './AddProps/TextColorProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import FontFamilyProp from './AddProps/FontFamilyProp.vue';
import FontSizeProp from './AddProps/FontSizeProp.vue';
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
import xmlModal from '../Reusables/xmlModal.vue';
import eventBus from '@/eventBus.js'


  export default {
    name: 'AddHeading',
    props: ['sharedData'],
    components: {TextEditorModal, xmlModal,
      TextColorProp, BackgroundColorProp, AlignmentProp, FontFamilyProp, FontSizeProp, PaddingProp, NameProp, ClassNamesProp, CopyBlock
      
    },
    data() {
    return {
      newClassName: '',
      openModal: false,
      isUniqueName: true,
      selectedText: '',
      openXmlModal: false,
      openConditionalText: false,
      color: null
    };
  },
    computed: {
      color: {
        get() {
          return this.sharedData?.data?.style?.color || null;
        },
        set(value) {
          if (!this.sharedData.data.style) this.sharedData.data.style = {};
          this.sharedData.data.style.color = value;
        },
      },
      level: {
        get() {
          return this.sharedData?.data?.props?.level|| 'h2';
        },
        set(value) {
          if (!this.sharedData.data.props) this.sharedData.data.probs = {};
          this.sharedData.data.props.level = value;
        },
      },
      activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
    },
    methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        this.activeSections = this.activeSections.filter(s => s !== section)
      } else {
        this.activeSections.push(section)
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section)
    },
    updateColor(payload) {
      console.log(payload.color)
        this.color = payload.color
    },
    // Event-Emitter für die Toolbar-Buttons – hier wird jeweils die sharedData.id (contentId) mitgegeben
    emitToggleItalic() {
      eventBus.emit('toggleItalic', { contentId: this.sharedData.id })
    },
    emitToggleUnderline() {
      eventBus.emit('toggleUnderline', { contentId: this.sharedData.id })
    },
    emitToggleStrike() {
      eventBus.emit('toggleStrike', { contentId: this.sharedData.id })
    },
    emitMarkPlaceholder() {
      eventBus.emit('markPlaceholder', { contentId: this.sharedData.id })
    },
    emitEnterRule() {
      eventBus.emit('enterRule', { contentId: this.sharedData.id })
    },
    emitAddLink() {
      eventBus.emit('addLink', { contentId: this.sharedData.id })
    },
    emitUndo() {
      eventBus.emit('undo', { contentId: this.sharedData.id })
    },
    emitRedo() {
      eventBus.emit('redo', { contentId: this.sharedData.id })
    },
    emitSuperscript() {
      eventBus.emit('superscript', { contentId: this.sharedData.id })
    },
    emitSubscript() {
      eventBus.emit('subscript', { contentId: this.sharedData.id })
    },
    emitColor(color) {
      this.color = color;
      eventBus.emit('toggleColor', { contentId: this.sharedData.id, colorCode: color })
    },
    emitResetColor(){
      this.color = null;
      eventBus.emit('resetColor', { contentId: this.sharedData.id})
    }
  },
  mounted() {
    eventBus.on('updateTextStyle', this.updateColor)
  },
  beforeUnmount() {
    eventBus.off('updateTextStyle', this.updateColor)
  },
    
  };
  </script>
 <style scoped>
 @import '../../styles/addComponents.css';
 button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 35px;
  font-size: 18px;
  background-color: transparent;
  color: black;
  border: 1px solid #ccc;
  transition: background-color 0.3s;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: rgb(241, 238, 238);
}

.toolbarIcon {
  font-size: 20px;
}

.wordLogo{
  height: 20px;
  width: 20px;
}

.toolbar {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 5px;
  max-width: 95%;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #cccc;
  margin-bottom: 30px;
}


button {
  padding: 5px 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}

button:hover {
  background-color: #ddd;
}


.openModalButton:hover {
  background-color: transparent;
}

.openModalButton{
  padding: 0px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-align: right;
  margin-top: 10px;
  margin-bottom: 10px;
 }

 
 </style>
 